import type { ImageUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteImageFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: ImageUpdatePanelFragment;
};

export function ImageUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteImageFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("ImageUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
